// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"248b7c58","453":"670e15c7","874":"bf2d2059"}[chunkId] + ".chunk.js";
};